export const EQUIPMENT = "EQUIPMENT";
export const MAINTENANCE_ITEM = "MAINTENANCE_ITEM";
